<template>
    <div class="link-page">
        <div class="center">
            <div class="link-block">
                <a :href="item.url" target="_blank" v-for="item in linkList" :key="item.id" class="link-item">
                    <img :src="item.image" alt="">
                    <h6>{{isCn?item.cnName:item.enName}}</h6>
                </a>
            </div>
        </div>
    </div>
</template>

<script>
import getLang from '@/utils/main/language';
import Layout from '@/views/Layout.vue';
import ajax from '@/utils/ajax';
import router from '@/router';

export default {
    name: 'aboutContact',
    components: {
        Layout,
    },
    data() {
        return {
            isCn: window.localStorage.getItem('show-lang') !== 'en',
            lang: getLang(),
            linkList: [],
        };
    },
    mounted() {
        this.getList();
    },
    methods: {
        goBack() {
            router.go(-1);
        },
        getList() {
            ajax.get('/web/friendship_link/list.json', {}).then((result) => {
                this.linkList = result.data;
            }).catch(() => {});
        },
    },
};
</script>
<style lang="less" scoped>
    .link-page {
        border-top: 8px solid #F8FAF9;
        padding-top: 25px;
    }
    .center {
        width: 960px;
        margin: 0 auto;
    }
    .block-title {
        color: #C71F4B;
        font-size: 18px;
        padding: 15px 0;
    }
    .link-block {
        width: 100%;
        margin-bottom: 16px;
        display:flex;
        flex-wrap: wrap;
        .link-item {
            display: block;
            position: relative;
            width: 310px;
            height: 260px;
            margin: 10px 5px;
            img {
                width: 310px;
                height: 235px;
            }
            h6 {
                position: relative;
                font-size: 14px;
                line-height: 25px;
                text-align: center;
            }
        }
    }
</style>
